import React, { forwardRef } from 'react';
import MUIDialog, {
  DialogProps as MUIDialogProps,
} from '@material-ui/core/Dialog';

type ExcludeDeprecatedProps = Omit<
  MUIDialogProps,
  | 'disableBackdropClick'
  | 'onBackdropClick'
  | 'onEnter'
  | 'onEntered'
  | 'onEntering'
  | 'onEscapeKeyDown'
  | 'onExit'
  | 'onExited'
  | 'onExiting'
  | 'onRendered'
>;

interface DialogProps extends ExcludeDeprecatedProps {}

const Dialog = forwardRef<HTMLDivElement, DialogProps>((props, ref) => {
  const {
    disableBackdropClick,
    onBackdropClick,
    onEnter,
    onEntered,
    onEntering,
    onEscapeKeyDown,
    onExit,
    onExited,
    onExiting,
    onRendered,
    ...rest
  } = props as MUIDialogProps;

  return (
    <MUIDialog {...rest} ref={ref}>
      {props.children}
    </MUIDialog>
  );
});

Dialog.displayName = 'Dialog';

export default Dialog;
